import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private journalIdSubject = new BehaviorSubject<string>('');
  private bookIdSubject = new BehaviorSubject<string>('');
  private userNameSubject = new BehaviorSubject<string>('');
  private usernameSubject = new BehaviorSubject<string | null>(null);
  private journalIdKey = 'journalId';
  private urlParamsSubject = new BehaviorSubject<any>(null);
  urlParams$ = this.urlParamsSubject.asObservable();
  isPlatformBrowser: boolean;
  @Inject(PLATFORM_ID) private platformId: any

  setUrlParams(params:any) {
    this.urlParamsSubject.next(params);
  }

  constructor(private sanitizer: DomSanitizer) { }

  setJournalId(journalId: string) {
    this.journalIdSubject.next(journalId);
  }

  getJournalId() {
    return this.journalIdSubject.asObservable();
  }

  setUsername(username: string) {
    this.usernameSubject.next(username);
  }
  getUsername() {
    return this.usernameSubject.asObservable();
  }

  loadScript(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      const script = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      const scriptElement = document.createElement('script');
      scriptElement.src = script.toString();
      document.body.appendChild(scriptElement);
    }
  }

}
